import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Navbar.css";
import UserDropdown from "../popup/MyProfile/UserDropdown";
import { baseURL } from "../../services/api";
import QuickAddButton from "./QuickAdd";
// import ProfileCompletion from "./ProfileCompletion";
import NotificationPopup from "../../pages/Accounts/Notification/NotificationMainPopup";
import { fetchUnreadCount } from "../../services/NotificationApi";
import LanguageSelector from "../common/Language Selector/LanguageSelector";
import useUserStore from "../../store/useUserStore";
import { useTranslation } from "react-i18next";

function Navbar() {
  const location = useLocation();
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const userData = useUserStore((state) => state.user);
  const [unreadCount, setUnreadCount] = useState(0);
  const { t } = useTranslation();
  

  const profile_url = userData?.profile_pic
    ? userData.profile_pic.startsWith("http")
      ? userData.profile_pic
      : `${baseURL.slice(0, -1)}/${userData.profile_pic.replace(/^\//, "")}`
    : null;

  useEffect(() => {
    loadUnread();
  }, []);

  async function loadUnread() {
    const count = await fetchUnreadCount();
    setUnreadCount(count);
  }

  const isRestrictedPath = ['/plans', '/plan-configure', '/plan-costomize'].some(path => location.pathname.startsWith(path));

  return (
    <div className="navbar">
      <div className="sub_navbar">
        <div
          className="logo-container"
          onClick={() => {
            if (isRestrictedPath) return;

            let baseUrl = "";

            if (window.location.hostname === "localhost") {
              baseUrl = "http://localhost:3000/";
            } else if (window.location.hostname.includes("staging")) {
              baseUrl = "https://salesroute-react-product.technaureus.com/";
            } else {
              baseUrl = "https://salesroute-react-product.technaureus.com/";
            }

            window.open(baseUrl, "_blank");
          }}
          style={{ cursor: isRestrictedPath ? "default" : "pointer" }}
        >
          <img src="/assets/logo1.png" alt="logo" className="logo" />
        </div>

        <div className="user-section">
          {/* Notification Icon */}
          {/* <ProfileCompletion /> */}
          <div
            className="notifications d-flex"
            onClick={() => {
              if (isRestrictedPath) return;
              setShowNotifications((prev) => !prev)
            }}
            style={{ position: "relative", cursor: isRestrictedPath ? "default" : "pointer" }}
            data-tooltip-id="global-tooltip"
            data-tooltip-content={t("Notifications")}
          >
            {unreadCount > 0 && (
              <span className="badge-red">{unreadCount}</span>
            )}

            <svg
              className="bell-icon"
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 17V18H0V17L2 15V9C2 5.9 4.03 3.17 7 2.29V2C7 1.46957 7.21071 0.960859 7.58579 0.585786C7.96086 0.210714 8.46957 0 9 0C9.53043 0 10.0391 0.210714 10.4142 0.585786C10.7893 0.960859 11 1.46957 11 2V2.29C13.97 3.17 16 5.9 16 9V15L18 17ZM11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19"
                fill="white"
              />
            </svg>
          </div>
          <LanguageSelector 
            data-tooltip-id="global-tooltip"
            data-tooltip-content={t("Language")}
          />
          {!isRestrictedPath && <QuickAddButton 
            data-tooltip-id="global-tooltip"
            data-tooltip-content={t("Quick Add")}
          />}
          <div className="user-info">
            <div
              className="user-image-container"
              onClick={() => {
                // if (isRestrictedPath) return;
                setShowProfileOptions((prev) => !prev);
              }}
              data-tooltip-id="global-tooltip"
              data-tooltip-content={t("Profile")}
              style={{
                cursor: "pointer"
              }}
            >
              <img
                src={profile_url || "/assets/no-profile.png"}
                alt="user profile"
                className="user-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Dropdowns */}
      <UserDropdown
        isOpen={showProfileOptions}
        onClose={() => setShowProfileOptions(false)}
        isRestricted={isRestrictedPath}
      />

      <NotificationPopup
        isOpen={showNotifications}
        onClose={() => setShowNotifications(false)}
      />
    </div>
  );
}

export default Navbar;
